"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagedComponent = void 0;
var preact_1 = require("preact");
var styles = require("./_managed-component.scss");
var connect = KalturaPlayer.ui.redux.connect;
var mapStateToProps = function (state) { return ({
    playerSize: state.shell.playerSize
}); };
var ManagedComponent = /** @class */ (function (_super) {
    __extends(ManagedComponent, _super);
    function ManagedComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ManagedComponent.prototype.update = function () {
        this.setState(function (prev) {
            return {
                toggler: !prev.toggler
            };
        });
    };
    ManagedComponent.prototype.shouldComponentUpdate = function (prevProps) {
        var _a = this.props, updateOnPlayerSizeChanged = _a.updateOnPlayerSizeChanged, playerSize = _a.playerSize;
        return (updateOnPlayerSizeChanged && prevProps.playerSize !== playerSize) || prevProps.playerSize === playerSize;
    };
    ManagedComponent.prototype.componentDidMount = function () {
        this.setState({
            toggler: false
        });
    };
    ManagedComponent.prototype.render = function () {
        var _a = this.props, fillContainer = _a.fillContainer, isShown = _a.isShown, playerSize = _a.playerSize;
        if (!isShown()) {
            return null;
        }
        return ((0, preact_1.h)("div", { "data-contrib-item": this.props.label, className: "".concat(fillContainer ? styles.fillContainer : '') }, this.props.renderChildren(playerSize)));
    };
    ManagedComponent.defaultProps = {
        fillContainer: false
    };
    ManagedComponent = __decorate([
        connect(mapStateToProps, null, null, { forwardRef: true })
    ], ManagedComponent);
    return ManagedComponent;
}(preact_1.Component));
exports.ManagedComponent = ManagedComponent;
//# sourceMappingURL=managed-component.js.map